import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CoreService {
  messageCount = new BehaviorSubject<any>(0);
  refferalEmail = new BehaviorSubject<string>('');
  constructor() {}
}
